import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ButtonIconSelectControl, ButtonSelect } from '../../Select'
import { DRAFT_CREATE_ACTION } from '../Draft.constants'
import { isDraftCreateNewAction } from '../Draft.utils'

function DraftCreateActionSelect({
  Control = ButtonIconSelectControl,
  controlProps: { Button: ControlButton, ...controlProps } = EMPTY_OBJECT,
  createNewLabelKey,
  draft,
  dropdownFloatingConfig: {
    maxWidthByRef = false,
    ...dropdownFloatingConfig
  } = EMPTY_OBJECT,
  initialValues,
  isSkeleton,
  listProps = EMPTY_OBJECT,
  openDraftLabelKey,
  onAction,
  ...selectProps
}) {
  function handleSelectItem({ value }) {
    const isCreateNew = isDraftCreateNewAction(value)

    onAction?.({
      action: value,
      initialValues: isCreateNew ? initialValues : draft,
    })
  }

  const { t } = useTranslation()

  const options = [
    { label: t(createNewLabelKey), value: DRAFT_CREATE_ACTION.createNew },
    { label: t(openDraftLabelKey), value: DRAFT_CREATE_ACTION.openDraft },
  ]

  return (
    <ButtonSelect
      {...selectProps}
      Control={Control}
      controlProps={{
        ...controlProps,
        Button: ControlButton,
        buttonProps: { ...controlProps.buttonProps, isSkeleton },
      }}
      dropdownFloatingConfig={{ ...dropdownFloatingConfig, maxWidthByRef }}
      listProps={listProps}
      options={options}
      onSelectItem={handleSelectItem}
    />
  )
}

export default DraftCreateActionSelect
